<template>
    <div class="tc-instrument-nested-menu-anchor">
        <div class="tc-top-color-menu" v-on:click.stop>
            <div class="tc-top-color-menu-item" v-for="color in colors"
                 :class="{'tc-top-color-menu-item-active': activeColorHex === color.hex}"
                 @click.stop="$emit('select', color)">
                <div class="tc-top-color-menu-item-inner"
                     :style="{'background-color': color.hex}">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ColorSelectMenu',
    props: [
        'activeColorHex',
        'colors',
    ],
    emits: [
        'select',
    ],
};
</script>

<style scoped lang="scss">

.tc-instrument-nested-menu-anchor {
    //position: absolute;
    width: 0;
    height: 0;
    z-index: 100;
}

.tc-top-color-menu {
    position: relative;
    top: 50px;
    width: max-content;
    height: max-content;
    padding: 10px;
    display: grid;
    grid-template-columns: max-content max-content max-content;
    grid-column-gap: 10px;
    grid-row-gap: 10px;
    background-color: white;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
    pointer-events: all;
}

.tc-top-color-menu-item {
    width: 30px;
    height: 30px;
    border: 1px solid transparent;
    border-radius: 100%;
    padding: 1px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 0.3s ease all;
}

.tc-top-color-menu-item:hover {
    border-color: #D9D9D9;
}

.tc-top-color-menu-item-active {
    border-color: #00458D !important;
}

.tc-top-color-menu-item-inner {
    width: 26px;
    height: 26px;
    border: 1px solid transparent;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
